import React from 'react';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
      ),
      title: 'AI-Mediated Communication',
      description: 'Navigate sensitive conversations with intelligent guidance that helps you express desires and boundaries with clarity and compassion.',
      features: ['Private input panels', 'Guided discussion prompts', 'Real-time sentiment analysis']
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
      title: 'Personalized Compatibility Insights',
      description: 'Discover deeper understanding through advanced analytics that reveal preference alignment, intimacy trends, and growth opportunities.',
      features: ['Compatibility scoring', 'Preference alignment charts', 'Personalized recommendations']
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
      title: 'Private Scheduling Tools',
      description: 'Coordinate intimate moments with intelligent scheduling that respects both partners\' availability, mood, and energy levels.',
      features: ['Mood-aware suggestions', 'Optimal timing recommendations', 'Discreet notifications']
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-foreground mb-4">
            Everything You Need to Nurture Your Connection
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Thoughtfully designed tools that respect the intimate nature of your relationship while providing powerful insights.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits?.map((benefit, index) => (
            <div
              key={index}
              className="bg-card border border-border rounded-xl p-8 shadow-therapeutic-sm hover:shadow-therapeutic transition-all duration-300"
            >
              <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center text-primary mb-6">
                {benefit?.icon}
              </div>
              <h3 className="font-heading text-xl font-semibold text-foreground mb-3">
                {benefit?.title}
              </h3>
              <p className="text-muted-foreground mb-6">
                {benefit?.description}
              </p>
              <ul className="space-y-2">
                {benefit?.features?.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start space-x-2 text-sm text-muted-foreground">
                    <svg className="w-5 h-5 text-success flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;